<template >
    <div style="padding-top:70px; padding-left:5%; padding-right:5%; margin-bottom:5%; background:black" > 
        <div class="loader">
            <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
        </div>



  </div>

</template>

<script>

import { mapGetters } from 'vuex';


  export default {
    name: 'app',
    data () {
      return {
          video:""
        
      }
    },
    methods:{




    },
   computed:{
    ...mapGetters(['pathAPI','userLogged', 'categorias', 'cursoSeleccionado']),

    },
    components:{

    },

    mounted: function(){
   
        const loader = document.querySelector(".loader")
        loader.className += " hidden"
        this.video = sessionStorage.video 

 
    },


  }
</script>


<style scoped>


</style>


// WEBPACK FOOTER //
// src/components/sections/Content.vue